import React from 'react'
import { Snackbar, IconButton } from '@material-ui/core'
import { CloseRounded } from '@material-ui/icons'
import { useObserver } from 'mobx-react-lite'

export default function CustomSuccessSnackbar(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { open, onClose, message } = props

  /**
  |--------------------------------------------------
  | Handle Close
  |--------------------------------------------------
  */
  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return
    }

    onClose(false)
  }

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return useObserver(() => (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      message={<span>{message}</span>}
      action={[
        <IconButton key="close" color="inherit" onClick={onClose}>
          <CloseRounded />
        </IconButton>
      ]}
    ></Snackbar>
  ))
}
